import { LOADER_ACTIVE } from 'constants/actionTypes';

const initialState = { active: false, loadingText: 'Calculating Plowprint Report'};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADER_ACTIVE:
      return action.status || initialState;
    default:
      return state;
  }
};